import { CollaboratorService } from './../../../../../rest/api/collaborator.service';
import { SpaceService } from './../../../../../services/space.service';
import { HelperService } from './../../../../../services/helper.service';
import { AuthService } from './../../../../../services/auth.service';
import { MemberService } from './../../../../../rest/api/member.service';
import { Component, OnInit, Input, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-collaborator-access',
  templateUrl: './collaborator-access.component.html',
  styleUrls: ['./collaborator-access.component.scss']
})
export class CollaboratorAccessComponent implements OnInit, OnChanges {
  @Input() selectedCollaborator;
  @Input() spaceListData;
  @Output() modelCloseEmit = new EventEmitter();
  @Output() collaboratorAccessEmit = new EventEmitter();

  accessToken: any;
  filteredSpaceData: any;
  loadingSpace = true;
  errors = [];
  successMsg: string;
  errorMsg: string;
  inputValue: any;
  isSubmitted = false;

  constructor(
    public fb: FormBuilder,
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    public spaceService: SpaceService,
    public collaboratorService: CollaboratorService,
    private router: Router
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.spaceListData && changes.spaceListData.currentValue) {
      this.loadingSpace = true;
      this.mapSpaceData();
    }
    if (changes && changes.selectedCollaborator && changes.selectedCollaborator.currentValue) {
      this.mapSpaceData();
    }
  }

  ngOnInit() {
  }

  mapSpaceData() {
    if (this.spaceListData && this.selectedCollaborator) {
      this.spaceListData = _.map(this.spaceListData, (space) => {
        let spaceAccess = 'noaccess';
        if (this.selectedCollaborator.space && this.selectedCollaborator.space.length > 0) {
          const spaceFound = _.find(this.selectedCollaborator.space, {id: space.uuid});
          if (spaceFound) {
            spaceAccess = spaceFound.role;
          }
        }
        space.spaceAccess = spaceAccess;
        return space;
      });
      this.filteredSpaceData = _.cloneDeep(this.spaceListData);
    }
  }

  searchSpace(value) {
    if (value && value !== '') {
      value = value.replace(/\s+/g, ' ').trim();
      value = value.toLowerCase();
      this.filteredSpaceData = _.filter(this.spaceListData, (res) => {
        let title;
        title = res.title;
        title = title.replace(/\s+/g, ' ').trim();
        title = title.toLowerCase();
        return title.includes(value);
      });
    } else {
      this.filteredSpaceData = _.cloneDeep(this.spaceListData);
    }
  }

  resetErrors() {
    this.successMsg = undefined;
    this.errorMsg = undefined;
    this.errors = [];
  }

  changeCollaboratorAccess(space, type) {
    this.isSubmitted = true;
    const formData = {
      email: this.selectedCollaborator.email,
      role: type,
      member_id: this.selectedCollaborator.member,
      space_id : space.uuid
    };
    const data = this.helperService.updateJsonFormat(formData);
    this.collaboratorService.spaceInviteCollaborator({
      Authorization: this.accessToken,
      body: data
    }).subscribe((response: any) => {
      this.successMsg = 'Role has been assigned to collaborator.';
      this.spaceListData = _.map(this.spaceListData, (list) => {
        if (list.uuid === space.uuid) {
          list.spaceAccess = type;
        }
        return list;
      });
      this.isSubmitted = false;
      this.filteredSpaceData = _.cloneDeep(this.spaceListData);
      this.collaboratorAccessEmit.emit({ id: space.uuid, role: type});
      setTimeout(() => {
        this.resetErrors();
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }


  handleErrors(err) {
    if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errors = err.error.errors;
    } else if (err && err.error && err.error.errors && err.error.errors[0]) {
      this.errorMsg = err.error.error;
    } else {
      this.errorMsg = 'There was error while assigning role to collaborator.';
    }
    this.isSubmitted = false;
    setTimeout(() => {
      this.resetErrors();
    }, 2000);
  }

  modalClose() {
    setTimeout(() => {
      this.modelCloseEmit.emit(true);
    }, 200);
  }

}
